import type { Scenario, ScenarioRepository } from './RepositoryInterfaces.js';

export class InMemoryScenarioRepository implements ScenarioRepository {
  private scenarios: Map<string, Scenario> = new Map();

  async findAll(): Promise<Scenario[]> {
    return Array.from(this.scenarios.values());
  }

  async findById(id: string): Promise<Scenario | undefined> {
    return this.scenarios.get(id);
  }

  async findByProjectId(projectId: string): Promise<Scenario[]> {
    return (await this.findAll()).filter((s) => s.projectId === projectId);
  }

  async save(scenario: Scenario): Promise<Scenario> {
    this.scenarios.set(scenario.id, scenario);
    return scenario;
  }

  async updateStatus(id: string, status: Scenario['status']): Promise<void> {
    const scenario = this.scenarios.get(id);
    if (scenario) {
      this.scenarios.set(id, { ...scenario, status });
    }
  }

  async delete(id: string): Promise<void> {
    this.scenarios.delete(id);
  }

  seed(scenarios: Scenario[]): void {
    scenarios.forEach((s) => this.scenarios.set(s.id, s));
  }
}

export const createInMemoryScenarioRepository = (): InMemoryScenarioRepository => new InMemoryScenarioRepository();
